<template>
  <div class="page_resume" v-loading="!isover">
    <Htitle title="候选人简历"></Htitle>
    <div class="resume_nav" v-if="mobiles.length>1">
      <div :class="isActive == index ? 'resume_nav_item isActive' :'resume_nav_item'" v-for="(item,index) in mobiles" :key="index" @click="changeResume(index)">简历{{ index+1 }}</div>
    </div>
    <div class="resume_info flex sb" v-if="!isNull(resumeInfo.msg) && isover">
      <div>
        <div class="resume_item">
          <div class="resume_item_title w3">创建人：</div>{{ resumeInfo.msgp.Creator }}
        </div>
        <div class="resume_item">
          <div class="resume_item_title">创建时间：</div>{{resumeInfo.msg.DtInsertDate.replace('T',' ')}}
        </div>
        <div class="resume_item">
          <div class="resume_item_title">渠道来源：</div>{{ resumeInfo.msg.strsource ? resumeInfo.msg.strsource : '-' }}
        </div>
        <div class="resume_item">
          <div class="resume_item_title w2">姓&nbsp;名：</div>{{ resumeInfo.msg.StrUserName }}
        </div>
        <div class="resume_item">
          <div class="resume_item_title">联系方式：</div>{{ resumeInfo.msg.StrMobile }}
        </div>
        <div class="resume_item">
          <div class="resume_item_title w2">年&nbsp;龄：</div>{{ resumeInfo.msg.StrUserAge ? resumeInfo.msg.StrUserAge : '-' }}
        </div>
        <div class="resume_item">
          <div class="resume_item_title w2">性&nbsp;别：</div>{{ resumeInfo.msg.BolUserSex ? resumeInfo.msg.BolUserSex : '-'  }}
        </div>
        <div class="resume_item">
          <div class="resume_item_title w2">学&nbsp;历：</div>{{ resumeInfo.msg.StrEduLvl ? resumeInfo.msg.StrEduLvl : '-'  }}
        </div>
        <div class="resume_item">
          <div class="resume_item_title">期望薪资：</div>{{ resumeInfo.msg.StrUserExpectSa ? resumeInfo.msg.StrUserExpectSa : '-'  }}
        </div>
        <div class="resume_item">
          <div class="resume_item_title">意向岗位：</div>{{ resumeInfo.msg.StrJobInf ? resumeInfo.msg.StrJobInf : '-' }}
        </div>
        <div class="resume_item">
          <div class="resume_item_title">求职意向：</div>{{ resumeInfo.msg.StrUserJobhunt ? resumeInfo.msg.StrUserJobhunt : '-'  }}
        </div>
        <div class="resume_item">
          <div class="resume_item_title w3">居住地：</div>{{ resumeInfo.msg.StrUserAdd ? resumeInfo.msg.StrUserAdd : '-'  }}
        </div>
      </div>
      <div>
        <img src="./components/edit.png" alt="" @click="editResume('编辑')">
      </div>
    </div>
    <div v-if="isNull(resumeInfo.msg) && isover">
      <el-empty description="暂无简历">
        <el-button type="primary" @click="editResume('新建')">新建简历</el-button>
      </el-empty>
    </div>
  </div>
</template>
    
<script>
import xz from "@/common";
import Htitle from "./components/header.vue";
export default {
  components: {
    Htitle
  },
  data() {
    return {
      //用户手机号码列表（可多个）
      mobiles: [],
      isActive: 0,
      resumeInfo: {
        msg: []
      },
      isover: false
    }
  },
  async created() {
    console.log('query',this.$route.query)
    if (this.$route.query.mobiles != undefined && this.$route.query.mobiles) {
      if(typeof(this.$route.query.mobiles)=='string'){
        this.mobiles = [];
        this.mobiles.push(this.$route.query.mobiles)
      }else{
        this.mobiles = this.$route.query.mobiles;
      }
      this.getResumeDtl(this.mobiles[0])
    }
  },
  mounted() {
  },
  methods: {
    changeResume(index) {
      this.isover = false;
      this.isActive = index;
      this.getResumeDtl(this.mobiles[index])
    },
    // 获取简历详情
    getResumeDtl(strMobile) {
      this.resumeInfo = {};
      this.loading = false;
      xz.getResumeDetail({ strMobile: strMobile }).then(res => {
        if (res.status == 'ok') {
          this.resumeInfo = res;
          this.isover = true
        } else {
          this.isover = true;
          this.resumeInfo = {
            msg: []
          };
          this.$toast.fail('获取用户简历出错')
        }
      });
      this.loading = false;
    },
    editResume(type) {
      if (type == '编辑') {
        let ResumeId = '';
        if (!this.isNull(this.resumeInfo.msg.ResumeId)) {
          ResumeId = this.resumeInfo.msg.ResumeId
        }
        this.$router.push({
          path: '/editResume',
          query: {
            type,
            ResumeId
          }
        })
      }else{
        this.$router.push({
          path: '/editResume',
          query: {
            type,
            mobile:this.mobiles[this.isActive]
          }
        })
      }
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
    }
  }
}

  </script>
 <style scoped>
.page_resume {
  background: #fff;
  height: 100vh;
}
.resume_nav {
  display: flex;
  justify-content: space-between;
}
.resume_nav_item {
  height: 34px;
  line-height: 34px;
  text-align: center;
  background: #f2f2f2;
  font-size: 14px;
  width: 50%;
  margin-right: 1px;
}
.isActive {
  background: #aaaaaa;
}
.resume_info {
  padding: 15px;
}
.resume_item {
  display: flex;
  font-size: 16px;
  line-height: 24px;
}
.resume_item_title {
  font-size: 16px;
  width: 5em;
  text-align-last: justify;
  letter-spacing: 0;
}
/* .w2{
  letter-spacing: 1em;
}
.w3{
  letter-spacing: 1/3em;
} */
</style>
    
 